import { useContext } from "solid-js"
import { ScenarioContext } from "./context"
import type { ScenarioStore } from "./types"

/**
 * Hook to access ScenarioStore from components
 * 
 * @returns [state, actions] tuple
 * @throws Error if used outside ScenarioProvider
 * 
 * @example
 * const [scenario, scenarioActions] = useScenarioStore()
 * console.log(scenario.agents)
 * scenarioActions.addAgent("person")
 */
export function useScenarioStore(): ScenarioStore {
	const context = useContext(ScenarioContext)
	if (!context) {
		throw new Error("useScenarioStore must be used within ScenarioProvider")
	}
	return context
}
